import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const MixedDataGlyph = /*#__PURE__*/createElement("g", {
  id: "mixedData",
  transform: "scale(3.6, 3.6)",
  fill: "none"
}, /*#__PURE__*/createElement("path", {
  d: "M5.41187 11L6.78843 6.8714M14.044 12.6134L8.6825 6.54793M16.0459 12.1026L17.7335 6.92297M7.41187 14C7.41187 15.6569 6.06872 17 4.41187 17C2.75501 17 1.41187 15.6569 1.41187 14C1.41187 12.3431 2.75501 11 4.41187 11C6.06872 11 7.41187 12.3431 7.41187 14ZM21.4119 4C21.4119 5.65685 20.0687 7 18.4119 7C16.755 7 15.4119 5.65685 15.4119 4C15.4119 2.34315 16.755 1 18.4119 1C20.0687 1 21.4119 2.34315 21.4119 4ZM9.41187 5C9.41187 6.10457 8.51643 7 7.41187 7C6.3073 7 5.41187 6.10457 5.41187 5C5.41187 3.89543 6.3073 3 7.41187 3C8.51643 3 9.41187 3.89543 9.41187 5ZM17.4119 14C17.4119 15.1046 16.5164 16 15.4119 16C14.3073 16 13.4119 15.1046 13.4119 14C13.4119 12.8954 14.3073 12 15.4119 12C16.5164 12 17.4119 12.8954 17.4119 14Z"
}));
const MixedData = createSvg({
  name: 'mixedData',
  path: MixedDataGlyph
});

export default MixedData;
export { MixedDataGlyph };
